import { render, staticRenderFns } from "./handle-dialog.vue?vue&type=template&id=1b41fd5f&scoped=true&"
import script from "./handle-dialog.vue?vue&type=script&lang=js&"
export * from "./handle-dialog.vue?vue&type=script&lang=js&"
import style0 from "./handle-dialog.vue?vue&type=style&index=0&id=1b41fd5f&scoped=true&lang=css&"
import style1 from "./handle-dialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b41fd5f",
  null
  
)

export default component.exports